import React from "react";

export const Loader = ({ active }) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center backGroundColor z-50">
      <div className="loader-new"></div>
    </div>
    // <div className="flex justify-center items-center h-screen">
    //     <div className="loader-new"></div>
    // </div>
  );
};

export const CommunityLoader = () => {
  return (
    <div className="flex justify-center items-center h-100">
      <div className="loader-new"></div>
    </div>
  );
};

export const CommunityLoadMoreLoader = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <div className="loader-new"></div>
    </div>
  );
};

export const CommonLoader = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <div className="loader-new"></div>
    </div>
  );
};
export default Loader;
